import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  Output,
  EventEmitter,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  KeyValues5,
  LocalService,
  PrintHtml,
} from '../../../service/local.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { PrintContent, PrintData } from 'src/app/entities/offline';
import { OfflineService } from 'src/service/offline.service';

@Component({
  selector: 'app-html-viewer',
  templateUrl: './html-viewer.component.html',
  styleUrls: ['./html-viewer.component.scss'],
})
export class HtmlViewerComponent implements OnInit {
  @Input() isIframe: boolean = false;
  lstSectionConfigKeys: string[] = ['paging'];
  @Input() content = '';
  @Input() contentLanguageId = '';
  @Input() isPopUp = false;
  maxBodyHeight = 0;
  @Output() onClose = new EventEmitter();
  @Input() printHtml: PrintHtml;

  sanitizedHtml;
  browserPrintingRenderingTime: number = 100;
  elementIds: any;
  htmlId: string = '';
  printers: KeyValues5[] = [];

  constructor(
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    public localService: LocalService,
    private languageManagementService: LanguageManagementService,
    private configurationManagementService: ConfigurationManagementService,
    private offlineService: OfflineService,
  ) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      iframe: 'iframe_' + this.htmlId,
    };
  }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(
      this.lstSectionConfigKeys,
    );

    this.configurationManagementService
      .getActiveLocalPrinterNamesMin(this.localService.basicParams.businessId)
      .subscribe((result) => {
        this.printers = result;
      });
    this.ngOnChanges();
  }

  ngOnChanges(): void {
    if (this.isIframe) {
      this.currentSinglePrintIndex = 0;
      this.isSinglePrint = false;
      this.isRunningOneByOne = false;
      this.onSetToIframe();
    } else {
      this.sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(this.content);
    }
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onClosePopup() {
    this.content = '';
    this.onClose.emit();
  }

  isPrint = false;
  printContent = '';
  onPrint() {
    const printerId = this.localService.onGetCurrentDeviceSettingsOfBusiness()?.QrLabelPrinterNameId;

    if (printerId) {
      const printerDetail = this.printers.find(x => x.key == printerId);

      if (printerDetail) {
        const payload = {
          values: [
            {
              htmlContent: this.content,
              printerNames: [printerDetail.v2],
              templateId: ""
            } as PrintContent,
          ],
          hostedUrl: printerDetail.v3,
          tempFolder: printerDetail.v4,
          isDirect: true
        } as PrintData;

        this.offlineService.setPrint(printerDetail.v3, payload).subscribe(result => {
          this.onPrinted();
        });
      }
    } else {
      if (this.isPrint) {
        this.isPrint = false;
      }
      this.printContent = this.content;
      this.isPrint = true;
    }
  }

  onPrinted() {
    this.printContent = '';
    this.isPrint = false;
    if (this.isRunningOneByOne) {
      this.onAction(5);
    }
  }

  currentSinglePrintIndex = 0;
  isSinglePrint = false;
  isRunningOneByOne = false;
  onSetContentFromHtmlPrint() {
    if (this.printHtml) {
      this.isSinglePrint = this.printHtml.isSinglePrint;
      if (this.printHtml.isSinglePrint) {
        const item = this.printHtml.values[this.currentSinglePrintIndex];
        this.content = this.localService.replaceAll(
          this.printHtml.html,
          '##ReplaceWithLabelContent##',
          item,
        );
      } else {
        this.content = this.printHtml.html;
      }
    }
  }

  onAction(index: number, isClicked = false) {
    switch (index) {
      case 1:
        {
          if (this.currentSinglePrintIndex >= 0) {
            this.currentSinglePrintIndex--;
            this.onSetToIframe(true);
          }
        }
        break;
      case 2:
        {
          if (this.currentSinglePrintIndex >= 0) {
            this.currentSinglePrintIndex--;
            this.onSetToIframe();
          }
        }
        break;
      case 3:
        {
          if (this.currentSinglePrintIndex < this.printHtml.values.length - 1) {
            this.currentSinglePrintIndex++;
            this.onSetToIframe();
          }
        }
        break;
      case 4:
        {
          if (this.currentSinglePrintIndex < this.printHtml.values.length - 1) {
            this.currentSinglePrintIndex++;
            this.onSetToIframe(true);
          }
        }
        break;
      case 5:
        {
          if (this.currentSinglePrintIndex < this.printHtml.values.length - 1) {
            this.isRunningOneByOne = true;
            if (!isClicked) {
              this.currentSinglePrintIndex++;
            }
            this.onSetToIframe(true);
          } else {
            this.currentSinglePrintIndex = 0;
            this.isRunningOneByOne = false;
          }
        }
        break;
      case 6:
        {
          this.isRunningOneByOne = false;
        }
        break;
      case 7:
        {
          this.currentSinglePrintIndex = 0;
          this.onSetToIframe();
        }
        break;
    }
  }

  onSetToIframe(isPrint = false) {
    this.onSetContentFromHtmlPrint();
    if (this.content && this.content.length > 5) {
      setTimeout(() => {
        const iframe: any = document.getElementById(this.elementIds.iframe);

        if (iframe) {
          let doc = iframe.contentWindow || iframe.contentDocument;
          if (doc.document) doc = doc.document;

          if (doc) {
            doc.open();
            doc.write(this.content);
            doc.close();
            if (isPrint) {
              this.onPrint();
            }
          }
        }
      }, this.browserPrintingRenderingTime);
    }
  }
}
